function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'navy': 'rgb(70, 91, 115)','mint': 'rgb(143, 212, 196)','fuchsia-pink': 'rgb(241, 91, 91)','yellow': 'rgb(245, 200, 65)','blush': 'rgb(217, 182, 174)','ocean': 'rgb(139, 163, 176)','sage': 'rgb(180, 194, 183)','lullaby-blue': 'rgb(169, 201, 223)','blue': 'rgb(169, 201, 223)','rose': 'rgb(213, 165, 173)','musk': 'rgb(205, 184, 186)','duck-egg': 'rgb(181, 210, 212)','bright-blue': 'rgb(98, 168, 220)','green': 'rgb(180, 194, 183)','bubblegum-echidna': 'rgb(115, 136, 194)','gumball-green-lizard': 'rgb(55, 111, 116)','lollipop-pink-wombat': 'rgb(210, 63, 84)','milkshake-pink-platypus': 'rgb(254, 179, 188)','bubblegum-blue-crocodile': 'rgb(115, 136, 194)','raspberry-red-turtle': 'rgb(188, 18, 61)','blueberry-pie-whaleshark': 'rgb(48, 59, 78)','chill': 'rgb(184, 205, 223)','spearmint': 'rgb(189, 220, 205)',};

    this.images = {};

    this.triggers = ['colour','color',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
